// @vendors
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

// @store
import useOnboardingStore from '../store/useOnboardingStore';
import { useSpinnerStore } from '../store/useSpinnerStore';

// @guards
import { NextStepGuardRouteString } from "../guards/NextStepGuard";

// @components
import TermsAndCondition from "./profileUser/components/TermsAndCondition";

const TermsAndConditionsPage: React.FC<{ onNext: () => void }> = ({
  onNext,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { acceptTermsAndConditions, isLoading } = useOnboardingStore(); // Store para aceptar términos y condiciones
  const [isChecked, setIsChecked] = useState(false); // Estado para manejar el checkbox
  const { openSpinner } = useSpinnerStore();

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsChecked(e.target.checked);
  };

  const handleSubmit = async () => {
    openSpinner(true);
    try {
      // Llamamos a la función del store para aceptar los términos
      await acceptTermsAndConditions(true);
      const redirectTo = NextStepGuardRouteString(); // Ajusta la redirección según tu configuración de rutas
      navigate(redirectTo); // Navegamos al siguiente paso
      onNext(); // Call onNext after successful submission
      openSpinner(false);
    } catch (error: any) {
      openSpinner(false);
      toast.error(t("onboarding.terms.error"));
    } finally {
      openSpinner(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col w-full">
      <div className="flex flex-col items-center mt-8 ">
        {/* Título */}
        <h1 className="text-[22px] font-bold text-red-500">
          {t("onboarding.terms.title")}
        </h1>
        <p className="text-sm text-gray-500 mt-2">
          {t("onboarding.terms.lastUpdate")}
        </p>

        {/* Texto de los términos */}
        <div
          className="mt-8 w-full px-4 bg-gray-100 p-6 rounded-lg shadow-md overflow-y-auto h-[80%] lg:h-[400px]"

        >
          <p className="text-lg font-bold">
            {t("onboarding.terms.termsTitle")}
          </p>

          <TermsAndCondition isOmboarding={true} />
        </div>

        <div className="flex flex-col lg:flex-row justify-between items-center  px-4  w-full ">
          {/* Aceptación de los términos */}
          <div className="flex items-center mt-6">
            <input
              type="checkbox"
              id="acceptTerms"
              checked={isChecked}
              onChange={handleCheckboxChange}
              className="mr-2"
            />
            <label htmlFor="acceptTerms" className="text-gray-700">
              {t("onboarding.terms.accept")}
            </label>
          </div>

          {/* Botón para aceptar */}
          <div className="mt-6 lg:mb-0 mb-6">
            <button
              type="button"
              onClick={handleSubmit}
              className={`bg-bgBrand text-white w-full px-12 py-3 rounded-lg ${!isChecked ? "opacity-50" : "hover:bg-red-600"
                } transition duration-300`}
              disabled={!isChecked || isLoading}
            >
              {isLoading
                ? t("onboarding.terms.loading")
                : t("onboarding.terms.acceptButton")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditionsPage;
